import React from "react";

const Hashed = () => {
  return (
    <div className="text-center p-5 drop-shadow-lg bg-white text-blue-800">
      <h3>hashes / s</h3>
      <h2 className="text-2xl text-orange-500">180</h2>
      <p>Approx. reward</p>
      <p>0.04752 BTC / day</p>
    </div>
  );
};

export default Hashed;
